import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LaminationService {

  


  // private apiUrl = "http://localhost:3003/api";
   private apiUrl = "https://lexipackghana.com:3003/api";


  constructor(private http: HttpClient) {}
 
 
  //add
  // addProduction(data: any, productionId: string) {
    
  //   return this.http.post(`${this.apiUrl}/production/${productionId}`, data);
  // }
  addLaminationProduction(data: any) {
    return this.http.post(`${this.apiUrl}/addLaminationProductionDetail`, data);
  }






  
  //
  // Method to call the new endpoint /laminations/by-id/:laminationId
  getProductionByproductionbyId(laminationId: string) {
    return this.http.get(`${this.apiUrl}/productions/by-id/${laminationId}`);
  }

  //get
  getAllLaminationProduction(){
    return this.http.get(this.apiUrl+'/laminations');
  }

  //getbyId
  getProductionById(id: string) {
    return this.http.get(this.apiUrl + '/lamination/' + id);
  }
  
  //update
    // Update lamination by laminationId (PUT)
    updateProduction(laminationId: string, data: any) {
      return this.http.put(`${this.apiUrl}/lamination/${laminationId}`, data);  // Use /production/:productionId endpoint
    }
  
 
    deleteLaminationProduction(id: string) {
    return this.http.delete(this.apiUrl + '/lamination/' + id);
  }
  
}
